import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import ComponentInfo from "./component-details/component-details-form";
import LastProcessorInfo from "./component-details/product-components";
import RawMaterialInfo from "./component-details/raw-material-info";
import { StyledButton } from "../../../../../shared/components/buttons/custom-button";
import CustomTable from "../../../../../shared/components/table/custom-table";
import { ActionsMenu } from "../../../../../shared/components/table/custom-actions";
import ActionsModalPopup, {
  ActionButtonConfig,
} from "../../../../../shared/components/modals/action-popup";
import CustomStepper from "../../../../../shared/components/stepper/steppers";
import {
  TCComponentData,
  TCComponentInformation,
  TCComponentRawMaterialInformation,
  TCProductComponentStandardInformation,
} from "../../../tc-models/tc-req-dto/tc-component-details.req_dto";
import {
  FloatingButtonContainer,
  InnerButton,
} from "../../../../../shared/components/buttons/floating-button-container";
import ProductComponent from "./component-details/product-components";
import {
  mapJsonToPayload,
  payloadToJsonMap,
} from "../../payload/component-details-payload";
import { transactionCertificateService } from "../../../tc-service/transaction-certificate.service";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { useFormActions } from "../../../../../shared/hooks/form-builder.hooks";
import useNotification from "../../../../../shared/hooks/useNotification";
import { useApi } from "../../../../../shared/hooks/useApi";
import { LoaderComponent } from "../../../../../shared/components/loaders/page-loader";
import {
  DELETECONFIG,
  TC_CREATE_ROUTE_CONFIG,
  TCAppConfig,
} from "../../../../../shared/app-configs/tc-app-configs";
import _ from "lodash";
import AlertPopup from "../../../../../shared/components/modals/alert-moadal";
import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";
import { Utills } from "../../../../../shared/app-configs/utilit";
import RenderDetailPanel from "./render-detail-panel";
import {
  ApiGetComponentList,
  Component,
  getProductShipmentDataByProductNo,
  getProductCategoryAndDetailCode,
  validateCertifiedProductFields,
  MappedComponentPayload,
  mapToApiComponentData,
} from "./component-details.model";
import { ApiShipmentResponseItem } from "../shipments/shipments.model";
import {
  fetchaddComponentDetails,
  mapComponentData,
} from "./component-details-apis";
import {
  getShipmentIdsByNumbers,
  ProductShipmentResponse,
} from "../certified-products/certified-products.model";
import { Pagination } from "../../../../../shared/hooks/useRecordStore";
// Initial State Definitions
const initComponentInfo: TCComponentInformation = {
  tcAssociatedProductNo: "",
  tcProductComponentOrder: "",
  tcProductComponentNo: "",
  tcComponentDetail: "",
  tcComponentInfoTrimsExcluded: "",
  tcComponentInfoAssociatedTc: "",
  tcComponentInfoFiberLength: "",
  tcComponentInfoYarnCount: "",
  tcComponentInfoFabricWeightAndConstruct: "",
  tcComponentInfoFabricWeightOfFinishedProduct: "",
  tcComponentNetShippingWeight: null,
  tcComponentSupplementaryWeight: null,
  tcComponentInfoAdditional: "",
};

const initStandardInfo: TCProductComponentStandardInformation[] = [];

const initRawMaterialInfo: TCComponentRawMaterialInformation[] = [];

const ComponentDetails = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [editingIndex, setEditingIndex] = useState<number>(-1);
  const { notify } = useNotification();
  const [stepData, setStepData] = useState({
    componentInfo: initComponentInfo,
    standardInfo: initStandardInfo,
    rawMaterialInfo: initRawMaterialInfo,
  });
  const navigate = useNavigate();
  const {
    getCurrentTableData,
    updateTableData,
    removeTableRowbyIndex,
    updateField,
    setDeleteSave,
    resetFormValueByPage,
  } = useFormActions("component-details");
  const { TE_ID, formtype } = useParams<string>();
  const [data, setData] = useState<any[]>([]);
  const { loading, executeGet, setLoadingState, executePost, executeDelete } =
    useApi();
  // Refs for Form Steps
  const { executeGet: executeaddGet } = useApi();
  const componentInfoRef = useRef<any>(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [apiData, setAPIData] = useState<[]>([]);
  const [pendingSave, setPendingSave] = useState<any | null>(null);
  const [originalValue, setOriginalValue] = useState("");
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [popUpTitle, setPopUpTitle] = useState<string>("");
  const [popUpBtnName, setPopUpBtnName] = useState<string>("");
  const hasSubmitTC: boolean = formtype === "submited-tc";
  const [isDeleteOnly, setDeleteOnly] = useState(false);
  const [productData, setProductData] = useState<ProductShipmentResponse[]>([]);
  const [tableData, setTableData] = useState<ApiGetComponentList>([]);
  const [productId, setProductId] = useState<string | null>(null);
  const [shipmentId, setShipmentId] = useState<string | null>(null);
  const [componentId, setComponentId] = useState<string | null>(null);
  const [tcComponentNo, setTcProductNo] = useState<string | null | undefined>(
    null
  );
  const { executeGet: executeShipment } = useApi();
  const [isNextEnabled, setNextEnabled] = useState<boolean>(false);
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState<number>(0);
  const [isValueChanged, setIsValueChanged] = useState<boolean>(false);
  const toggleDrawer = () => {
    setActiveStep(0);
    if (drawerOpen) {
      setStepData({
        componentInfo: initComponentInfo,
        standardInfo: initStandardInfo,
        rawMaterialInfo: initRawMaterialInfo,
      });
      setProductId(null);
      setShipmentId(null);
      setComponentId(null);
      setEditingIndex(-1);
      setPendingSave(null);
      setIsValueChanged(false);
    }
    setDrawerOpen((prev) => !prev);
    setRestrictPopUpSave(false);
  };
  const { isRestrictPopUpSave, setRestrictPopUpSave } =
    useTransactionCertificateStore();
  const shipmentFormData = async () => {
    try {
      const response = await executeShipment(
        TCAppConfig.GET_PRODUCT_RAWMATERIAL_INFO_LIST,
        { tcId: TE_ID }
      );
      setProductData(response?.data.response);
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };

  const handleDataUpdate = (stepKey: string, updatedData: any) => {
    setStepData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
  };

  const fetchComponentDetails = async () => {
    try {
      const response: any = await executeGet(
        TCAppConfig.GET_COMPONENT_DETAILS_LIST,
        { 
          tcId: TE_ID,
          limit: pagination?.pageSize,
          offset: pagination?.pageIndex * pagination?.pageSize
        }
      );
      const result = response.data;
      console.log(result.response);
      setTableData(result.response);
      setAPIData(result.response);
      setRowCount(response?.data?.no_of_records);
      setDeleteSave(false);
      setNextEnabled(true);
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };

  const setZustandInitialState = (initialState?: any) => {
    // //alert(initialState)
    const defalutState: any = {
      tcProductComponentOrder: "",
      tcProductComponentNo: "",
      tcComponentDetail: "",
      tcAssociatedProductNo: "",
      tcComponentInfoTrimsExcluded: "",
      tcComponentInfoAssociatedTc: "",
      tcComponentInfoFiberLength: 0,
      tcComponentInfoYarnCount: 0,
      tcComponentInfoFabricWeightAndConstruct: 0,
      tcComponentInfoFabricWeightOfFinishedProduct: 0,
      tcComponentNetShippingWeight: null,
      tcComponentSupplementaryWeight: null,
      tcComponentInfoAdditional: 0,
      "standard-info": [],
      "raw-materials-info": [],
    };
    //set zustand state inital values
    Object.entries(initialState ?? defalutState).forEach(([key, value]) => {
      updateField(key, value);
    });
  };

  useEffect(() => {
    // setZustandInitialState(null)
    // const componentDetailsData = getCurrentTableData()
    // Utills.cl(`componentDetailsData ${componentDetailsData}`)
    // if (componentDetailsData) {
    //   setData(componentDetailsData)
    // }
    if (TE_ID) {
      fetchComponentDetails();
      shipmentFormData();
    } else {
      // TO DO Port Changes 4
      updateTableData([]);
    }
    // TO DO Port Changes 5
    resetFormValueByPage();
    setZustandInitialState();
    setRestrictPopUpSave(false);
  }, [TE_ID, pagination?.pageIndex]);

  const steps = [
    {
      label: "Component Info",
      content: (
        <ComponentInfo
          formRef={componentInfoRef}
          componentData={stepData.componentInfo}
          setComponentData={(data) => handleDataUpdate("componentInfo", data)}
        />
      ),
    },
    {
      label: "Standard Info",
      content: (
        <ProductComponent
          productInfoData={stepData.standardInfo}
          setProductInfoData={(data) => handleDataUpdate("standardInfo", data)}
        />
      ),
    },
    {
      label: "Raw Material Info",
      content: (
        <RawMaterialInfo
          rawMaterialInfoData={stepData.rawMaterialInfo}
          setRawMaterialInfoData={(data) =>
            handleDataUpdate("rawMaterialInfo", data)
          }
        />
      ),
    },
  ];

  const handleNext = async () => {
    if (activeStep === 0 && componentInfoRef?.current) {
      try {
        const errors = await componentInfoRef.current.validateForm();
        await componentInfoRef.current.submitForm();
        if (Object.keys(errors).length === 0) {
          setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
        } else {
          notify("Please fill in all required fields correctly", "error");
        }
      } catch (error) {
        console.error("Form submission error:", error);
      }
    } else {
      // For steps without form refs (like step 1 - Standard Info)
      setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
    setRestrictPopUpSave(false);
  };
  const handleFinish = async () => {
    if (TE_ID) {
      const componentNo = stepData?.componentInfo?.tcProductComponentNo || "";
      const associatedProductNo = stepData?.componentInfo?.tcAssociatedProductNo || "";

      // Check if component number is empty or invalid
      const isComponentNoEmpty = (value: string): boolean => {
        if (!value || value.trim() === "") return true;
        const trimmedValue = value.trim().toLowerCase();
        const invalidValues = ['n/a', 'n\\a', 'null', 'not available', 'na', 'nil'];
        return invalidValues.some(invalid => trimmedValue === invalid);
      };

      if (isComponentNoEmpty(componentNo) && associatedProductNo) {
        try {
          // Find the product in productData
          const associatedProduct = productData.find(p => p.tcProductNo === associatedProductNo);
          
          if (!associatedProduct) {
            notify("Associated product not found", "error");
            return;
          }

          // Fetch the Certified Product data for the associated product
          const productResponse = await executeGet(TCAppConfig.GET_PRODUCT_RAWMATERIAL_INFO_NEW, {
            tcId: TE_ID,
            productId: associatedProduct.productId,
            shipmentId: associatedProduct.shipmentId,
          });

          if (productResponse?.data?.tcProductInformation?.[0]) {
            const productInfo = productResponse.data.tcProductInformation[0]; 
            const productCodes = getProductCategoryAndDetailCode(productData, associatedProductNo);
            
            if (productCodes) {
              const validation = validateCertifiedProductFields(
                componentNo,
                productCodes.tcProductCategoryCode,
                productCodes.tcProductDetailCode,
                productInfo.tcProductInfoFiberLength || "",
                productInfo.tcProductInfoYarnCount || "",
                productInfo.tcProductInfoFabricWeightAndConstruct || "",
                productInfo.tcProductInfoFabricWeightOfFinishedProduct || ""
              );

              if (!validation.valid) {
                validation.errors.forEach(error => {
                  const autoHideDuration = error.includes("Fabric Weight of Finished Product") ? 10000 : 5000;
                  notify(error, "error", { autoHideDuration });
                });
                return; 
              }
            }
          }
        } catch (err) {
          console.error("Failed to validate Certified Product fields:", err);
          notify("Failed to validate Certified Product fields", "error");
          return;
        }
      }

      let newComponentId = componentId;
      const existingComp = tableData?.find(
        (comp) => comp?.componentId === componentId
      );
      if (componentId) {
        if (
          existingComp?.tcProductComponentNo !==
          stepData?.componentInfo.tcProductComponentNo
        ) {
          newComponentId = null;
        }
      }
      console.log("stepData ----> ", stepData);
      const payload = mapComponentData(stepData, TE_ID, newComponentId);
      console.log("payload ----> ", payload);
      const isSuccess = await handleSave(payload);
      if (newComponentId !== componentId && componentId && isSuccess) {
        //if component no has been changed in edit
        setTcProductNo(existingComp?.tcProductComponentNo);
        handleConfirmSave(null, true, existingComp?.tcProductComponentNo); //silently delete old component
      }
    }
  };

  const actions: ActionButtonConfig[] = [
    ...activeStep!==0?[{
      label: "Back",
      onClick: handleBack,
      variant: "contained" as "contained",
      color: "default" as "default",
      disabled: activeStep === 0,
    }]:[],
    {
      label: activeStep === steps.length - 1 ? "Save" : "Next",
      onClick: activeStep === steps.length - 1 ? handleFinish : handleNext,
      variant: "contained" as "contained",
      color: "primary" as "primary",
      disabled: activeStep === 2 || activeStep === 1 ? isRestrictPopUpSave : false,
    },
  ];

  const columns: MRT_ColumnDef<any>[] = [
    {
      accessorKey: "tcAssociatedProductNo",
      header: "Associated Product No.",
      enableHiding: false,
      minSize: 60,
      maxSize: 150,
    }, //TC Associated Product No renamed to match field
    {
      accessorKey: "tcProductComponentNo",
      header: "Component No.",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "tcComponentDetail",
      header: "Component Detail",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "tcComponentNetShippingWeight",
      header: "Net Shipping Weight (kg)",
      minSize: 60,
      maxSize: 150,
      Cell: Utills.usNumberFormat,
    },
    {
      accessorKey: "tcComponentSupplementaryWeight",
      header: "Supplementary Weight (kg)",
      minSize: 60,
      maxSize: 150,
      Cell: Utills.usNumberFormat,
    },
  ];
  const handleSave = async (payload: MappedComponentPayload) => {
    let isSaveSuccess: boolean = false;
    if (!TE_ID) {
      return;
    }
    //"test")
    setLoadingState(true);
    const shipmentData = getProductShipmentDataByProductNo(
      productData,
      payload.tcComponentInformation[0].tcAssociatedProductNo
    );
    //"test2")
    const queryParams = new URLSearchParams({
      tcId: TE_ID,
      shipmentId: shipmentData ? JSON.stringify(shipmentData.shipmentId) : "",
      productId: shipmentData?.productId ? shipmentData?.productId : "",
      shipmentNo: encodeURIComponent(
        shipmentData ? JSON.stringify(shipmentData.tcProductShipmentNo) : ""
      ),
    }).toString();

    const oldProductId = productId ? productId : shipmentData?.productId;
    const oldShipmentIdArray = shipmentId
      ? [shipmentId]
      : shipmentData?.shipmentId;
    // const oldProductIdParam = JSON.stringify(oldProductIdArray);
    const oldShipmentIdParam = JSON.stringify(oldShipmentIdArray);
    const finalUrl = `${TCAppConfig.COMPONENT_DETAILS_ENDPOINT}?${queryParams}&oldProductId=${oldProductId}&oldShipmentId=${oldShipmentIdParam}`;
    const result: any = await executePost(finalUrl, payload);
    // transactionCertificateService.saveComponentDetails(payload)
    if (result.status == 200) {
      isSaveSuccess = true;
      notify("Data Saved Successfully", "success");
      toggleDrawer();
      if (pendingSave) {
        setPendingSave(null);
      }
      fetchComponentDetails();
      setStepData({
        componentInfo: initComponentInfo,
        standardInfo: initStandardInfo,
        rawMaterialInfo: initRawMaterialInfo,
      });

      setComponentId(null);
      setIsValueChanged(false);
    } else {
      setLoadingState(false);
      notify("Unable to Save", "error");
    }
    return isSaveSuccess;
  };

  const onEdit = (row: any) => {
    const value = row?.original as Component;
    setComponentId(value.componentId);
    setShipmentId(value.shipmentId);
    setProductId(value.productId);
    setIsValueChanged(false);
    if (TE_ID) {
      fetchaddComponentDetails(
        executeaddGet,
        TE_ID,
        value.shipmentId,
        value.productId,
        value.componentId
      )
        .then((data) => {
          console.log("dataaa", data);
          const productList = data?.data?.tcComponentInformation;

          if (productList && productList.length > 0) {
            const product = productList[0];
            console.log("product", product);
            const mappedStepData = mapToApiComponentData(product);
            console.log("mappedStepData", mappedStepData);
            setStepData(mappedStepData);
          }

          // Open the drawer after fetching and mapping data
          toggleDrawer();
        })
        .catch((err) => notify(err.message, "error"));
    }

    // Set additional state
    setEditingIndex(row.index);
    setZustandInitialState(value);
  };

  const onDelete = (row: any) => {
    const tcComponentNo = row?.original?.tcProductComponentNo;
    const productId = row?.original?.productId;
    setTcProductNo(tcComponentNo);
    setProductId(productId);
    setShipmentId(row?.original?.shipmentId);
    setComponentId(row?.original?.componentId);

    setDialogOpen(true);
    setPopUpBtnName("Yes");
    setPopUpTitle("Confirm Delete ?");
    setPopUpMessage(`Are you sure want to delete it`);
  };
  const onEditDelete = (row: any) => {
    const tcComponentNo = row?.original?.tcProductComponentNo;
    const productId = row?.original?.productId;
    setTcProductNo(tcComponentNo);
    setProductId(productId);
    setShipmentId(row?.original?.shipmentId);
    setComponentId(row?.original?.componentId);

    setDialogOpen(true);
    setPopUpBtnName("Save");
    setPopUpTitle("Confirm Save ?");
    setPopUpMessage(
      `Editing Component No. ${tcComponentNo} will remove all the Associated Records, are you sure want to edit it`
    );
  };
  const handleNavigate = () => {
    navigate(`/tc/${formtype}/tc-standard-weight/${TE_ID}`);
  };
  const handleConfirmSave = async (
    e: any = null,
    isSilent = false,
    compNo: string | null | undefined = null
  ) => {
    try {
      // If we have a pending save payload, save it first
      if (pendingSave) {
        delete pendingSave.componentId;
        await handleSave(pendingSave);
        setPendingSave(null);
      }

      // Then delete the existing record
      const res = await executeDelete(`${TCAppConfig.TC_DELETE_API}`, {
        pageName: DELETECONFIG.component,
        tcId: TE_ID,
        componentId: componentId,
        shipmentId: shipmentId,
        productId: productId,
        componentNo: encodeURIComponent(
          encodeURIComponent(isSilent ? compNo ?? "" : tcComponentNo ?? "")
        ),
      });

      if (res?.status === 200) {
        fetchComponentDetails();
        setDialogOpen(false);
        setComponentId("");
        setProductId("");
        setShipmentId("");
        if (!isSilent) {
          notify("Successfully processed", "success");
        }
      }
    } catch (error) {
      console.error("Error in handleConfirmSave:", error);
      notify("Failed to process the request", "error");
    }
  };
  const handleCancelSave = () => {
    setDialogOpen(false);
    if (drawerOpen) {
      toggleDrawer();
    }
  };
  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <Box display="flex" mb={3} justifyContent="flex-end" width="100%">
            {!hasSubmitTC && (
              <StyledButton variant="contained" onClick={toggleDrawer}>
                Add Component
              </StyledButton>
            )}
          </Box>
          <Box display="grid">
            <CustomTable
              columns={columns}
              data={tableData}
              rowCount={rowCount}
              paginations={pagination}
              setPaginations={setPagination}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              enableRowActions={!hasSubmitTC}
              renderDetailPanel={({ row }) =>
                // Only mount the detail panel if the row is expanded
                row.getIsExpanded() ? (
                  <RenderDetailPanel row={row} />
                ) : (
                  <>NO data</>
                )
              }
              renderRowActions={({ row }) => (
                <ActionsMenu row={row} onEdit={onEdit} onDelete={onDelete} />
              )}
            />
          </Box>
          <ActionsModalPopup
            open={drawerOpen}
            onClose={toggleDrawer}
            title="Add Component"
            actions={actions}
          >
            <CustomStepper
              steps={steps}
              activeStep={activeStep}
              onStepChange={(step) => setActiveStep(step)}
            />
          </ActionsModalPopup>

          {!drawerOpen ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
                gap: "0.5rem",
              }}
            >
              {/* {!isNextEnabled && <InnerButton onClick={handleSave}>Save & Next</InnerButton>} */}
              <NavLink to="/tc-dashboard">
                <InnerButton>Home</InnerButton>
              </NavLink>
              {isNextEnabled && (
                <InnerButton onClick={handleNavigate}>Next</InnerButton>
              )}
            </Box>
          ) : (
            <>
              {TE_ID && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 2,
                    gap: "0.5rem",
                  }}
                >
                  {hasSubmitTC && (
                    <NavLink to={`/tc/${formtype}/tc-standard-weight/${TE_ID}`}>
                      <InnerButton>Back</InnerButton>
                    </NavLink>
                  )}
                  <InnerButton onClick={handleNavigate}>Next</InnerButton>
                </Box>
              )}
            </>
          )}

          <AlertPopup
            open={dialogOpen}
            title={popUpTitle}
            message={popUpMessage}
            onClose={handleCancelSave}
            onConfirm={handleConfirmSave}
            confirmText={popUpBtnName}
            cancelText="Cancel"
          />
        </>
      )}
    </>
  );
};

export default ComponentDetails;
